import { DisbursementType } from 'src/settings/settings';
import { Bank } from 'src/types';

export interface ContributionYearData {
  contributionYearCode: number;
  amount: number;
}

export enum SystematicTransactionStatus {
  CREATE = 'CREATE',
  MODIFY = 'MODIFY',
  DELETE = 'DELETE',
}

export interface SystematicActivitySchedule {
  deferMonths?: number[];
  investedEveryMonth: boolean;
  transferDays: number[];
  transferMonths: number[];
  contributionYear?;
}

export interface SystematicTransaction {
  agreementId: string;
  amount: number;
  disbursementType: DisbursementType;
  iraWithholding: number;
  sourceAgreementId: string;
  systematicActivitySchedule: SystematicActivitySchedule;
  systematicTransactionStatus: SystematicTransactionStatus;
  systematicTransactionType: 'EXCHANGE' | 'PURCHASE' | 'REDEEM';
  electionAgreementUniqueId1: number;
  electionAgreementUniqueId2: number;
}

export interface ExchangeTransactionSubmissionPayload {
  currentPaperlessConsent: boolean;
  paperlessConsent: boolean;
  systematicTransactions: SystematicTransaction[];
}

export interface RecurringPurchaseTransactionPayload
  extends ExchangeTransactionSubmissionPayload {
  bankDto: Partial<Bank>;
}
